<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form label-width="150px" :model="dataForm">
        <el-form-item label="支出金额：">
          {{ dataForm.Amount }}
        </el-form-item>
        <el-form-item label="资金来源：">
          {{ showSource(dataForm.Source) }}
        </el-form-item>
        <el-form-item label="受赠者类型：">
          {{ showRecipientType(dataForm.RecipientType) }}
        </el-form-item>
        <el-form-item label="公益项目名称：" v-if="dataForm.Source == 0">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="受赠者：">
          {{ dataForm.RecipientName }}
        </el-form-item>
        <el-form-item label="支出说明标题：">
          {{ dataForm.ExplainTitle }}
        </el-form-item>
        <el-form-item label="支出说明：">
          {{ dataForm.Explain }}
        </el-form-item>
        <el-form-item label="支出时间：">
          {{ (dataForm.FinishTime * 1000) | formatDate2 }}
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";
import { saveAs } from 'file-saver';

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formTitle: "查看详情",
      width: "60%",
      fileList:[]//附件数组
    };
  },
  computed: {
    showRecipientType() {
      return (data) => {
        switch (data) {
          case 0:
            return "个人";
          case 1:
            return "单位";
          case 2:
            return "企业";
        }
      };
    },
    showSource() {
      return (data) => {
        switch (data) {
          case 0:
            return "社会捐赠";
          case 1:
            return "财政拨款";
          case 2:
            return "其他";
        }
      };
    },
  },
  components: {
    OfDialog,
  },
  mounted(){
      let that=this;
      that.getfile();
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.of-dialog >>> .el-button--primary {
  display: none;
}
.of-dialog >>> .el-button--default {
  display: none;
}
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo>>>.el-upload-dragger{
    display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
</style>
